import { Link } from 'react-router-dom';
import { categories } from '@/mocks/videos';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-300">
      <div className="container-page py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4 whitespace-nowrap">
              <div className="w-9 h-9 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-movie-2-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">麻花视频</span>
            </Link>
            <p className="text-sm text-background-400 leading-relaxed">
              麻花视频提供海量电视剧免费在线观看，涵盖最新电视剧全集、高清不缓冲播放。电影免费看，无需会员即可享受流畅观影体验。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">内容分类</h4>
            <ul className="flex flex-col gap-2.5">
              {categories.map((cat) => (
                <li key={cat.slug}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer whitespace-nowrap"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="flex flex-col gap-2.5">
              <li>
                <Link to="/" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#faq" className="text-sm text-background-400 hover:text-background-100 transition-colors duration-200 cursor-pointer whitespace-nowrap">
                  常见问题
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm font-semibold text-background-50 mb-4">联系方式</h4>
            <ul className="flex flex-col gap-2.5">
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-mail-line"></i>
                <span>contact@mahuavideo.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-phone-line"></i>
                <span>400-888-6666</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-400">
                <i className="ri-map-pin-line"></i>
                <span>北京市朝阳区光华路9号</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-10 pt-6 border-t border-background-700 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 麻花视频 MahuaVideo. 保留所有权利。
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">隐私政策</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">服务条款</a>
            <a href="#" className="text-xs text-background-500 hover:text-background-300 transition-colors cursor-pointer whitespace-nowrap">版权声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}